import { render, staticRenderFns } from "./BaseChartCard.vue?vue&type=template&id=600a5ea9&"
import script from "./BaseChartCard.vue?vue&type=script&lang=js&"
export * from "./BaseChartCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('600a5ea9')) {
      api.createRecord('600a5ea9', component.options)
    } else {
      api.reload('600a5ea9', component.options)
    }
    module.hot.accept("./BaseChartCard.vue?vue&type=template&id=600a5ea9&", function () {
      api.rerender('600a5ea9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Bases/Cards/BaseChartCard.vue"
export default component.exports